'use strict';

const Marked = require('marked');
const Sanitizer = require('common/util/sanitizer');

const baseURL = `${location.protocol}//${location.host}`;

const markedOptions = function () {
    let options = {
        renderer: new Marked.Renderer(),
        gfm: true,
        lfm: true,
        tables: true,
        breaks: true,
        pedantic: false,
        sanitize: true,
        smartLists: true,
        smartypants: false
    };

    return options;
};

const sanitizedHTML = function(markdown) {
    const marked = new Marked.setOptions(markedOptions());
    return Sanitizer.sanitize(marked(markdown));
};

module.exports = function() {
    return sanitizedHTML;
};



// WEBPACK FOOTER //
// ./balus/util/marked.js